/* eslint-disable no-nested-ternary,no-unused-vars */
/* global G */
import { curry, isObj } from 'lib/util'
import find from 'lib/sequence/component/children/find'
import { setData as setModelData } from 'lib/sequence/model/api/set'
import { get, set } from 'lib/sequence/component/state/value'
import sequenceComponentState from 'lib/sequence/component/state'
import { empty } from 'lib/util/object'
import { disable, enable } from 'lib/sequence/component/state/disabled'
import reset from 'app/_shared/component/reset'

const {
  get: getConfiguration,
  set: setConfiguration,
} = sequenceComponentState('configuration')

const clearObject = object => Object.keys(object).reduce((acc, key) => {
  const value = object[key]
  acc[key] = value && isObj(value) ? clearObject(value) : value === true ? false : null
  return acc
}, {})

const clearErrors = array => array?.map(({ error, errorText, items, ...item }) => ({
  ...item, ...items ? { items: clearErrors(items) } : {},
})) || array

/**
 * Clears the current state of the `dynamicData` component and resets the attribute of the current
 * model with the same name.
 *
 * @type {Gaia.AppModule.EventHandler}
 */
const clearDynamicData = async (module, component, event) => {
  const model = module[G.MODEL]
  const rootComponent = module[G.STATE][G.ACTION][G.COMPONENT]

  const { detail } = find(rootComponent)
  const { dynamicData: dynamicForm, save, clear } = find(detail)

  const configuration = getConfiguration(dynamicForm)
  const data = get(dynamicForm)

  reset(dynamicForm)

  setConfiguration(dynamicForm, clearErrors(configuration))

  if (data && !empty(data)) {
    const clearedData = clearObject(data)

    setModelData(model, { dynamicData: clearedData }, { updateCache: true })
    set(dynamicForm, clearedData)
  }

  disable(clear)
  enable(save)

  await module[G.ADAPTER][G.UI].update(module)
}

export default curry(clearDynamicData)
